// state/uiThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { enableFullscreen, disableFullscreen } from "./uiSlice";
import { requestFullscreen, exitFullscreen } from "./../../helpers/Fullscreen";

export const toggleFullscreenThunk = createAsyncThunk("ui/toggleFullscreenThunk", async (_, { getState, dispatch }) => {
  const state = getState() as RootState;
  const isFullscreen = state.uiSlice.isFullscreen;

  if (!isFullscreen) {
    await requestFullscreen();
    dispatch(enableFullscreen());
  } else {
    await exitFullscreen();
    dispatch(disableFullscreen());
  }
});
